const LARGE_NUMBER = 5000;

interface Response {
  nextToken: string;
}

/**
 * Successively fetches data until it fetches all or the limit is hit.
 *
 * @param fetchNext - Fetches the next data from the nextToken.
 * @param handleResponse - Fn that handles the response and returns the results.
 * @param limit - Stops fetching after the number of results hits this limit.
 */
export default async function fetchAllPaginated<R extends Response>(
  fetchNext: (nextToken: string) => Promise<R | null>,
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  handleResponse: (response: R) => Array<any>,
  limit: number = LARGE_NUMBER
): Promise<void> {
  let nextToken = '';
  let totalNumResults = 0;
  do {
    const response = await fetchNext(nextToken);
    if (response == null) {
      return;
    }
    nextToken = response.nextToken;
    // Defensively abort if nextToken is not set somehow, avoids infinite loops
    if (nextToken == null) {
      return;
    }
    const results = handleResponse(response);
    if (results.length === 0) {
      return;
    }
    totalNumResults += results.length;
  } while (nextToken !== '' && totalNumResults < limit);
}
